"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldEnableNewNavigation = exports.generateSupportUrl = exports.isFreemiumEdition = exports.shouldHidePPExperience = void 0;
var FREE = "free";
var GROWTH = "growth";
/**
 * @internal
 */
function shouldHidePPExperience(featureFlags) {
    var hidePPExperience = Boolean(featureFlags.hidePixelPerfectExperience);
    var enablePPExperience = featureFlags.enablePixelPerfectExperience;
    var isFreemiumUser = isFreemiumEdition(featureFlags.platformEdition);
    return hidePPExperience || (isFreemiumUser && !enablePPExperience);
}
exports.shouldHidePPExperience = shouldHidePPExperience;
/**
 * @internal
 */
function isFreemiumEdition(platformEdition) {
    return platformEdition === FREE || platformEdition === GROWTH;
}
exports.isFreemiumEdition = isFreemiumEdition;
/**
 * @internal
 */
function generateSupportUrl(projectId, sessionId, userEmail, url) {
    if (projectId === void 0) { projectId = ""; }
    if (sessionId === void 0) { sessionId = ""; }
    if (userEmail === void 0) { userEmail = ""; }
    if (url === void 0) { url = ""; }
    return [
        "https://support.gooddata.com/hc/en-us/requests/new",
        "?ticket_form_id=582387",
        "#sessionID=" + encodeURIComponent(sessionId),
        "&projectID=" + encodeURIComponent(projectId),
        "&email=" + encodeURIComponent(userEmail),
        "&url=" + encodeURIComponent(url),
    ].join("");
}
exports.generateSupportUrl = generateSupportUrl;
/**
 * @internal
 */
function shouldEnableNewNavigation(featureFlags) {
    var enableNewNavigationForResponsiveUi = Boolean(featureFlags.enableNewNavigationForResponsiveUi);
    if (enableNewNavigationForResponsiveUi) {
        var platformEdition = featureFlags.platformEdition;
        // Free: always true
        if (platformEdition === FREE) {
            return true;
        }
        // Growth/Enterprise: with PP: false, without PP: On demand
        return shouldHidePPExperience(featureFlags);
    }
    return false;
}
exports.shouldEnableNewNavigation = shouldEnableNewNavigation;
//# sourceMappingURL=featureFlags.js.map